export const TIPI_ORA = [
  { k: "ordinario", label: "Ordinario", magg: null },
  { k: "straordinario", label: "Straordinario", magg: "straordinario" },
  { k: "straordinario_festivo", label: "Straordinario festivo", magg: "straordinario_festivo" },
  { k: "sabato", label: "Sabato", magg: "sabato" },
  { k: "domenica", label: "Domenica", magg: "domenica" },
  { k: "notturno", label: "Notturno", magg: "notturno" },
];
export const TIPO_ORA_LABEL = Object.fromEntries(TIPI_ORA.map((t) => [t.k, t.label]));
export const MAGGIORAZIONI = [
  { k: "straordinario", label: "Straordinario ordinario", def: 25 },
  { k: "straordinario_festivo", label: "Straordinario festivo", def: 50 },
  { k: "sabato", label: "Sabato", def: 10 },
  { k: "domenica", label: "Domenica", def: 30 },
  { k: "notturno", label: "Notturno", def: 30 },
];
export const etichettaTipoOra = (tipo, impostazioni) => {
  const t = TIPI_ORA.find((x) => x.k === tipo) || TIPI_ORA[0];
  const p = t.magg ? impostazioni?.maggiorazioni?.[t.magg] : null;
  return p != null ? `${t.label} (+${p}%)` : t.label;
};
